import React, { useEffect } from "react";
import InputComponent from '../../Components/InputComponent'

/*
This is a component that displays all the information of an input in the edit pop up window when we edit a data element.
At this point we meet input only inside a form data element.
*/
const EditInputComponent = (props) => {

    const {
        componentId,
        index,
        index2,
        componentsInfo,
        setComponentsInfo,
        rowsComponentsIds,
        setRowsComponentsIds,
        setAdded,
        added,
        clickedEdit,
        editor,
        infoSummary,
        setInfoSummary,
        initComponentsInfo,
        setInitComponentsInfo,
        deleteComps,
        setDeleteComps
    } = props

    const [typeInfo, setTypeInfo] = React.useState([]);
    const [placeholder, setPlaceholder] = React.useState();
    const [required, setRequired] = React.useState(false);


    useEffect( () => {

        const tempComponentsInfo = [...componentsInfo];

        if(initComponentsInfo === true && componentId !== -1){

            const domComponents = editor.DomComponents;
            const inputComponent = domComponents.componentsById[componentId];

            if(inputComponent !== undefined){

                tempComponentsInfo[index].info[index2].type = inputComponent.attributes.attributes.type;
                tempComponentsInfo[index].info[index2].placeholder = inputComponent.attributes.attributes.placeholder;
                tempComponentsInfo[index].info[index2].required = inputComponent.attributes.attributes.required;

                setTypeInfo(inputComponent.attributes.attributes.type);
                setPlaceholder(inputComponent.attributes.attributes.placeholder);
                setRequired(inputComponent.attributes.attributes.required); 

                const tempInfoSummary = [...infoSummary];
                tempInfoSummary[index2].placeholder = inputComponent.attributes.attributes.placeholder;
                tempInfoSummary[index2].type = inputComponent.attributes.attributes.type;
                setInfoSummary(tempInfoSummary);
            }      
        }
        setComponentsInfo(tempComponentsInfo);

    },[clickedEdit])

    useEffect( () => {


        setTypeInfo(componentsInfo[index].info[index2].type);
        setPlaceholder(componentsInfo[index].info[index2].placeholder);
        setRequired(componentsInfo[index].info[index2].required); 
        
    },[added])

    /*
    This function change the type of input component inside an edited data element window 
    and store its value to use it if we want to generate a block 
    */
    const changeType = (option) => {
        setTypeInfo(option);
        
        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info[index2].type = option;
        setComponentsInfo(tempComponentsInfo);

        const tempInfoSummary = [...infoSummary];
        tempInfoSummary[index2].type = option;
        setInfoSummary(tempInfoSummary);

    }

    /*
    This function change the value of placeholder of input component inside an edited data element window 
    and store its value to use it if we want to generate a block
    */
    const changePlaceholder = (val) =>{
        setPlaceholder(val.target.value);
        
        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info[index2].placeholder = val.target.value;
        setComponentsInfo(tempComponentsInfo);


        const tempInfoSummary = [...infoSummary];
        tempInfoSummary[index2].placeholder = val.target.value;
        setInfoSummary(tempInfoSummary);
    }

    /*
    This function controls the 'required' attribute of input component, and stores the checked value (true or false)
    to use it if we later want to generate a block.
    */
    const changeCheckbox = () => {

        const tempComponentsInfo = [...componentsInfo];

        if( required === true){
            setRequired(false);
            tempComponentsInfo[index].info[index2].required = false;
        }
        else{
            setRequired(true);
            tempComponentsInfo[index].info[index2].required = true;
        }

        setComponentsInfo(tempComponentsInfo);
        
    }

    /* 
    This function deletes the input component of the edited data element window and
    of the information about the block that we keep and renders again
    */ 
    const deleteElement = () => {

        const tempDeleteComps = [...deleteComps];
        tempDeleteComps.push(rowsComponentsIds[index].insideIds[index2]);
        setDeleteComps(tempDeleteComps)

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].div.splice(index2,1);
        tempComponentsInfo[index].info.splice(index2,1);
        setComponentsInfo(tempComponentsInfo);
        
        const tempRowsComponentsIds = [...rowsComponentsIds];
        tempRowsComponentsIds[index].insideIds.splice(index2,1);
        setRowsComponentsIds(tempRowsComponentsIds);

        setInitComponentsInfo(false);
        setAdded(true);
    }

    return(
        <InputComponent
            deleteComponent = {deleteElement}
            typeInfo = {typeInfo}
            changeType = {changeType}
            placeholder = {placeholder}
            changePlaceholder = {changePlaceholder}
            required = {required}
            changeCheckbox = {changeCheckbox}
        />
    )
};

export default EditInputComponent;